export default "__VITE_ASSET__8c66b12a__"